module.exports = __webpack_public_path__ + "static/other/picture_wall.b97ce987.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/fitFiveGame/picture_wall.json
// module id = 2378
// module chunks = 0